module.exports = __webpack_public_path__ + "img/Aperature Priority-Med.21d1adb7.jpg";